// calculatorSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  investmentAmmount: "100000",
  noOfFDYear: "5",
  incrementPerYear: "6.5",
  fdErrors: null,
};

const fdSlice = createSlice({
  name: "fdCalculator",
  initialState,
  reducers: {
    setInvestmentAmounts: (state, action) => {
      state.investmentAmmount = action.payload;
    },
    setnoOfFDYear(state, action) {
      state.noOfFDYear = action.payload;
    },
    setIncrementPerYear(state, action) {
      state.incrementPerYear = action.payload;
    },
    setFdErrors(state, action) {
      state.fdErrors = action.payload;
    },
    SetSumAmount(state, action) {
      state.sumAmount = action.payload;
    },
    resetFdData: (state) => {
      return initialState;
    },

    setRemoveFields(state) {
      state.investmentAmmount = "";
      state.incrementPerYear = "";
      state.noOfFDYear = "";
      state.fdErrors = null;
    },
  },
});
export const {
  setIncrementPerYear,
  setInvestmentAmounts,
  setnoOfFDYear,
  setFdErrors,
  SetSumAmount,
  resetFdData,
} = fdSlice.actions;
export const { setActiveCalculator } = fdSlice.actions;
export default fdSlice.reducer;
